import { RootState } from "../store";

export const getAllCities = (state: RootState) => state.city.allCities;
export const getCity = (state: RootState) => state.city.city;
export const getCreatedCity = (state: RootState) => state.city.createdCity;
export const getDeletedCity = (state: RootState) => state.city.deletedCity;
export const getUpdatedCity = (state: RootState) => state.city.updatedCity;
export const getCityNameById = (state: RootState) => (id: string) => {
  const cityFound = state.city.allCities.data?.results.find((f) => f.id === id);
  if (!cityFound) return "Città non disponibile";
  return cityFound.name;
};
export const getCityById = (state: RootState) => (id: string) => {
  const cityFound = state.city.allCities.data?.results.find((f) => f.id === id);
  return cityFound;
};
export const getAllCitiesAsOption = (state: RootState) => {
  if (getAllCities(state).data)
    return getAllCities(state).data?.results.map((city) => ({
      value: city.id,
      label: city.name,
    }));

  return [];
};
